import { Status } from "@/types/containerTypes";
import { ReportParams, ReportType } from "@/types/reportTypes";

export class Report {
  id: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  title: string;
  status?: Status;
  reportCreator: string;
  reportDate?: Date | string;
  requirement: string;
  testMethod: string;
  testPlanNumber: string;
  testPlanRevision: string;
  type: ReportType;
  reportTemplateId?: string;
  isPreview: boolean;
  propelOrgId: string;
  projectId?: string;
  /** set on a coded report template: the coded run report its procedure's runs get */
  reportKey: string | null;

  constructor(params: ReportParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.title = params.title || '';
    this.status = params.status;
    this.reportCreator = params.reportCreator || '';
    this.reportDate = params.reportDate;
    this.requirement = params.requirement || '';
    this.testMethod = params.testMethod || '';
    this.testPlanNumber = params.testPlanNumber || '';
    this.testPlanRevision = params.testPlanRevision || '';
    this.type = params.type;
    this.reportTemplateId = params.reportTemplateId;
    this.isPreview = params.isPreview || false;
    this.propelOrgId = params.propelOrgId;
    this.projectId = params.projectId;
    this.reportKey = params.reportKey || null;
  }
}
